<template>
    <div class='w-full flex dx-field'>
        <div v-if='meta.title' class='dx-field-label'>{{ meta.title }}</div>
        <div class='dx-field-value'>
            <dx-drop-down-box
                width='100%'
                ref='dropBoxRef'
                :data-source='displayData'
                :value='value'
                :display-expr="meta.fieldNameText"
                :value-expr="meta.fieldNameId"
                :disabled='disabled'
                @contentReady="onContentReady"
            >
                <div style='height: 200px;'>
                    <ai-grid-ro
                        ref='dataListRef'
                        :meta='meta'
                        :args="args"
                        :showToolbar="false"
                        :showFilterPanel="false"
                        :showGridFooter="false"
                        :show-column-headers='false'
                        :show-search-panel='false'
                        @row-click='onSelectValue'
                    />
                </div>
            </dx-drop-down-box>
        </div>
    </div>
</template>

<script setup>
import { DxDropDownBox } from 'devextreme-vue/drop-down-box';
import AiGridRo from '@/components/ai-grid-ro/ai-grid-ro.vue';
import { computed, ref } from 'vue';

const props = defineProps({
    value: {
        default: null,
        required: true,
        type: [String, Number, null],
    },
    meta: {
        type: Object,
        default: () => {}
    },
    dataSource: {
        type: Array,
        default: () => []
    },
    disabled: {
        type: Boolean,
        default: () => false
    },
    args: {
        type: Object,
        default: () => {},
    },
})

const emits = defineEmits(['selectedValue'])

const dropBoxRef = ref(null);

const displayData = computed(() => props.dataSource);

const onSelectValue = (event) => {
    dropBoxRef.value?.instance?.close();
    emits('selectedValue', event.data[props.meta.fieldNameId]);
}

const onContentReady = (e) => {
    if (!e.component.__initDropDownContainer) {
        e.component.__initDropDownContainer = true;
        e.component.option('dropDownOptions.container', e.element.parentElement);
    }
}
</script>

<style scoped>

</style>
